import { render, staticRenderFns } from "./Students.vue?vue&type=template&id=d6669c5a&scoped=true"
import script from "./Students.vue?vue&type=script&lang=js"
export * from "./Students.vue?vue&type=script&lang=js"
import style0 from "./Students.vue?vue&type=style&index=0&id=d6669c5a&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6669c5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6669c5a')) {
      api.createRecord('d6669c5a', component.options)
    } else {
      api.reload('d6669c5a', component.options)
    }
    module.hot.accept("./Students.vue?vue&type=template&id=d6669c5a&scoped=true", function () {
      api.rerender('d6669c5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolManage/students/Students.vue"
export default component.exports